import { useEffect, useState } from "react";

export function LogTypeSelect({ logType, setLogType }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLogType(event.target.value);
  };

  useEffect(() => {
    if (logType !== "" && logType !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [logType]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={logType} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="Sentry Biometrics">Sentry Biometrics</option>
        <option value="Mobile Biometrics">Mobile Biometrics</option>
      </select>
    </div>
  );
};